import React, { Fragment, useEffect } from 'react';
import { Flex } from 'antd';
import { FormikProps } from 'formik';

import { ShopValues } from '../service/shop.interface';
import { renderField } from '../../promocodes/utils/fields';
import { getShopFields } from '../utils/fields';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import {
    generateImage,
    selectAIImageState,
    setPrompt,
} from '../../../../ai/store/aiImage.slice';

export interface Props {
    readonly formik: FormikProps<Partial<ShopValues>>;
    readonly disabledFields?: string[];
}

export const ShopForm = ({ formik, disabledFields = [] }: Props) => {
    const dispatch = useAppDispatch();

    const { prompt } = useAppSelector(selectAIImageState);

    const handleCreateAIImageByText = (value: string) => {
        if (value) {
            dispatch(setPrompt(value));
        }
    };

    useEffect(() => {
        if (prompt) {
            dispatch(generateImage(prompt));
        }
    }, [prompt]);

    return (
        <form>
            <Flex vertical gap={24}>
                {getShopFields().map(field =>
                    field.hidden?.(formik.values) ? null : (
                        <Fragment key={field.name}>
                            {renderField(field, formik, {
                                disabledFields,
                                onBlur: handleCreateAIImageByText,
                            })}
                        </Fragment>
                    )
                )}
            </Flex>
        </form>
    );
};
